<template>
  <v-app>
    <v-app-bar app dark dense v-if="needToShow">
      <v-toolbar-title class="mr-2">Monitor Webapp</v-toolbar-title>

      <template v-if="!$store.getters.isSimple">
        <network-status></network-status>

        <scheduler-status></scheduler-status>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon class="ml-5" small v-on="on" @click="openNotifications">
              <v-icon color="orange">mdi-message-alert</v-icon>
            </v-btn>
          </template>
          <span>Pop-up Notifications</span>
        </v-tooltip>

        <restart-server-action></restart-server-action>

        <v-tooltip bottom v-if="$store.getters.isAdmin && $store.getters.isDev">
          <template v-slot:activator="{ on }">
            <v-btn icon class="ml-5" small v-on="on" @click="doToggleDebug">
              <v-icon :color="debug ? 'green' : 'gray'">mdi-bug</v-icon>
            </v-btn>
          </template>
          <span>Toggle Debug</span>
        </v-tooltip>

        <v-tooltip bottom v-if="$store.getters.isAdmin">
          <template v-slot:activator="{ on }">
            <v-btn icon class="ml-5" small v-on="on" @click="doTogglePreview">
              <v-icon :color="testPreview ? 'green' : 'gray'">mdi-test-tube</v-icon>
            </v-btn>
          </template>
          <span>Toggle Preview</span>
        </v-tooltip>

        <v-tooltip bottom v-if="$store.getters.isAdmin">
          <template v-slot:activator="{ on }">
            <v-btn icon class="ml-5" small v-on="on" @click="doToggleTestWarnings">
              <v-icon :color="testWarnings ? 'green' : 'gray'">mdi-alert-decagram</v-icon>
            </v-btn>
          </template>
          <span>Toggle Test Warnings</span>
        </v-tooltip>
      </template>

      <v-spacer></v-spacer>
      <template v-if="$store.getters.isAuthenticated">
        <template v-if="!$store.getters.isSimple">
          <on-duty></on-duty>
        </template>

        <router-link to="/poker" class="ml-2 mr-2"><v-btn text>Poker</v-btn></router-link>

        <template v-if="!$store.getters.isSimple">
          <router-link to="/" class="mr-2"><v-btn text>Chat</v-btn></router-link>
          <router-link to="/mining" class="mr-2" v-if="$store.getters.isMiner"><v-btn text>Mining</v-btn></router-link>
          <router-link to="/archive" class="mr-2" v-if="$store.getters.isAdmin || $store.getters.isManager || $store.getters.isChatManager"><v-btn text>Archive</v-btn></router-link>
          <router-link to="/chatbot" class="mr-2" v-if="$store.getters.isAdmin"><v-btn text>Chatbot</v-btn></router-link>
          <router-link to="/admin" class="mr-2" v-if="$store.getters.isAdmin"><v-btn text>Admin</v-btn></router-link>
        </template>

        <span class="mr-4">
          <strong>Logged in as {{ $store.state.user.user }}</strong>
        </span>
        <v-btn @click="$store.dispatch('logout')" color="primary" small>Logout</v-btn>
      </template>
      <template v-else>
        <router-link to="/login"><v-btn>Login</v-btn></router-link>
      </template>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>

    <template v-if="userInactive">
      <div class="d-flex justify-center align-center" style="z-index: 100000; background: rgba(0, 0, 0, 0.9); position: absolute; width: 100%; height: 100%; top:0; left:0">
        <span>It looks like you are inactive. Refresh the page to continue using the site.</span>
      </div>
    </template>
  </v-app>
</template>

<script>
import NetworkStatus from "./components/NetworkStatus";
import OnDuty from './components/OnDuty';
import SchedulerStatus from "./components/SchedulerStatus";
import {mapState} from "vuex";
import RestartServerAction from "@/components/RestartServerAction";

export default {
  components: {RestartServerAction, SchedulerStatus, NetworkStatus, OnDuty},
  computed: {
    ...mapState([
      'debug',
      'testPreview',
      'testWarnings',
      'userInactive',
    ]),
    needToShow() {
      const notShow = this.isSMSPage || this.isTelegramPage || this.isQuestionsPage || this.isPokerTablePage || this.isNotificationsPage || this.isChatHistoryPage;
      return !notShow;
    },
    isChatHistoryPage() {
      return this.$route.name === "ChatHistory";
    },
    isTelegramPage() {
      return this.$route.name === "Telegram";
    },
    isQuestionsPage() {
      return this.$route.name === "Questions";
    },
    isPokerTablePage() {
      return this.$route.name === "Table";
    },
    isNotificationsPage() {
      return this.$route.name === "Notifications";
    },
    isSMSPage() {
      return this.$route.name === "SMS";
    },
  },

  data() {
    return {
      time: null,
    }
  },

  mounted() {
    window.addEventListener('load', this.resetTimer, true);
    var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    events.forEach((name) => {
        document.addEventListener(name, this.resetTimer, true);
    });
  },

  methods: {
    openNotifications() {
      window.open(
          `/notifications`,
          "",
          "width=600,height=400,left=200,top=200"
      );
    },
    doToggleDebug() {
      this.$store.commit('toggleDebug');
    },
    doTogglePreview() {
      this.$store.commit('togglePreview');
    },
    doToggleTestWarnings() {
      this.$store.commit('toggleTestWarnings');
    },
    resetTimer() {
      clearTimeout(this.time);
      this.time = setTimeout(this.inactive, 1000 * 10 * 60);
    },
    inactive() {
      this.$store.commit('markUserInactive');
      this.$socket.disconnect();
    }
  }
}
</script>
